import React, { Fragment } from 'react';

import { Column, ColumnContainer, Divider, LoadingContainer } from '@beacharound/beacharound-ui';

export default function ProductsTable({ data, isLoading, daysNum, hidePrice }) {

    return (
        <LoadingContainer isLoading={isLoading}>
            {data?.length > 0 &&
                <Fragment>
                    <ColumnContainer lowMargin>
                        <Column>
                            <table style={{
                                width: '100%',
                                border: '1px solid #c8ced3',
                                borderCollapse: 'collapse'
                            }}>
                                <tbody>
                                    <tr style={{ border: '1px solid #c8ced3' }}>
                                        <th style={{ padding: '5px 10px', border: '1px solid #c8ced3' }} align="left">
                                            Prodotti prenotabili
                                        </th>

                                        {!hidePrice &&
                                            <th style={{ padding: '5px 10px', border: '1px solid #c8ced3' }} align="right">
                                                Prezzi
                                            </th>
                                        }
                                    </tr>

                                    {data?.filter(elem => Math.floor(elem?.price / daysNum) >= 1)?.sort((a, b) => a.price - b.price).map((item, index) => {
                                        const name = item?.mainItem?.name ? `${item?.mainItem?.name} con ${item?.name}` : item?.name;
                                        const price = Math.floor(item.price / daysNum).toFixed(2);

                                        return (
                                            <tr key={index}>
                                                <td style={{ padding: '2px 10px', border: '1px solid #c8ced3' }}>{name}</td>
                                                {!hidePrice && <td style={{ padding: '2px 10px', border: '1px solid #c8ced3' }} align="right">{`A partire da ${price} €`}</td>}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </Column>
                    </ColumnContainer>
                    <Divider />
                </Fragment>
            }
        </LoadingContainer>
    );
}